var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import mixin from './mixin';
export default function () {
    var AFRAME = window.AFRAME || {};
    if (typeof AFRAME === 'undefined') {
        throw new Error('Component attempted to register before AFRAME was available.');
    }
    AFRAME.registerComponent('drop-down', __assign(__assign({ schema: {
            value: { type: 'string', default: '' },
            options: { type: 'string', default: '' },
        }, init: function () {
            var el = this.el;
            var data = this.data;
            this.render();
        } }, mixin), { getWidth: function () {
            var _a;
            return parseFloat("".concat(((_a = this === null || this === void 0 ? void 0 : this.container) === null || _a === void 0 ? void 0 : _a.getAttribute('menu-item-width')) || 0));
        }, getHeight: function () {
            var _a;
            return parseFloat("".concat(((_a = this === null || this === void 0 ? void 0 : this.container) === null || _a === void 0 ? void 0 : _a.getAttribute('menu-item-height')) || 0));
        }, render: function () {
            var _this = this;
            var el = this.el;
            var me = this;
            try {
                var options = JSON.parse(this.data.options);
                if (options === null || options === void 0 ? void 0 : options.length) {
                    if (me.container) {
                        me.container.parentNode.removeChild(me.container);
                    }
                    var container_1 = document.createElement('frame-menu-container');
                    container_1.setAttribute('forward-step', '0.05');
                    var option = options.find(function (font) { return font.value === _this.data.value; });
                    container_1.setAttribute('text-value', (option === null || option === void 0 ? void 0 : option.name) || this.data.value || '-- - Select-- - ');
                    container_1.setAttribute('menu-direction', 'down');
                    container_1.setAttribute('flex-direction', 'column');
                    container_1.setAttribute('justify-content', 'flex-start');
                    container_1.setAttribute('align-items', 'flex-start');
                    container_1.setAttribute('padding', '0.01');
                    container_1.setAttribute('menu-item-height', ".2");
                    container_1.setAttribute('menu-item-width', "1.0");
                    this.container = container_1;
                    options.forEach(function (font) {
                        var menuItem = document.createElement('frame-base-interactive'); // Assuming 'frame-base-interactive' is a custom component or styled div
                        menuItem.setAttribute('font-size', '.07');
                        menuItem.setAttribute('value', font.value);
                        menuItem.setAttribute('title', font.name);
                        menuItem.setAttribute('interactive-type', 'button');
                        menuItem.setAttribute('width', '1');
                        menuItem.setAttribute('height', '.2');
                        menuItem.setAttribute('margin', '0 0 0.05 0');
                        container_1.appendChild(menuItem);
                    });
                    el.appendChild(container_1);
                    me.updateElementSize(me, me.el);
                }
            }
            catch (e) {
                console.error(e);
            }
        }, 
        /**
         * Called when component is attached and when component data changes.
         * Generally modifies the entity based on the data.
         */
        update: function (oldData) {
            if (oldData.options !== this.data.options) {
                this.render();
            }
            if (this.data.value !== oldData.value) {
                this.container.setAttribute('text-value', this.data.value || '-- - Select-- - ');
            }
        }, remove: function () { }, pause: function () { }, play: function () { } }));
    AFRAME.registerPrimitive('frame-drop-down', {
        defaultComponents: {
            'drop-down': {}
        },
        mappings: {
            //gui item general
            'options': 'drop-down.options',
            'value': 'drop-down.value'
        }
    });
}
